const LAST = "lamka_thrift_last_visit";
const PREV = "lamka_thrift_prev_visit";

// Previous visit time, fixed for this browser session so badges survive reloads.
export const previousThriftVisit = () => {
  let prev = sessionStorage.getItem(PREV);
  if (prev === null) {
    prev = localStorage.getItem(LAST) || "";
    sessionStorage.setItem(PREV, prev);
    localStorage.setItem(LAST, new Date().toISOString());
  }
  return prev ? new Date(prev) : null;
};

export const isNewSince = (item, since) => !!since && !!item.created_at && new Date(item.created_at) > since;
